import AuthBackgroundImage from '../../../shared/components/AuthImage/AuthBackgroundImage'
import { FaCheck } from 'react-icons/fa'
import './ListClientImgRow.css'

function ListClientImgRow({ dataArray, handleOnSelect, selectedArray }) {

    const isSelected = (item) => !!selectedArray && selectedArray.some((i) => i._id === item._id)

    if (!dataArray || dataArray.length === 0) return null

    return (
        <div className="cimg-grid">
            {dataArray.map((item) => (
                <div
                    key={item._id}
                    className={`cimg-tile ${isSelected(item) ? 'cimg-tile-selected' : ''}`}
                    onClick={() => handleOnSelect(item)}
                >
                    <AuthBackgroundImage className="cimg-tile-bg" src={item.image ? `/images/clientImg/${item.image}` : null} />
                    {isSelected(item) && (
                        <span className="cimg-tile-check"><FaCheck size={11} /></span>
                    )}
                </div>
            ))}
        </div>
    )
}

export default ListClientImgRow
